import React from 'react';
import ScrollArea from 'react-scrollbar';
import $ from 'jquery';
import RegionService from '../../../services/region.service';
import i18n from '../../../i18n';
import { dateInUTC, removeSpecialCharacter } from '../../../utility/utility';
import { ServerService as instanceService } from './../../../services/server.service';
import { AuditLog } from '../../../services/auditlog.service';
import ReactToolTip from 'react-tooltip';
import Axios from 'axios';
import { API_HOST, axiosRequestWithAuth } from '../../../constants/server.constant';
import { loginService } from '../../../services/login.service';

export default class InstanceMigration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isregionselected: false,
            regionListFilter: [],
            regionList: [],
            regions: [],
            allRegions: [],
            countryName: '',
            selectedRegion: '',
            dropRegion: '',
            instanceName: '',
            keyName: '',
            region: '',
            isAccept: false,
            migrateCount: -1,
            isCreateExternalDisabled: !loginService.isInternalUser()
        };
        this.scrollRef = React.createRef();
    }

    componentDidMount() {
        $('.migrate_slider').removeClass('active');
        this.loadRegions();
        this.loadAllRegions();
        this.setImageRegionDetails();
    }

    loadRegions = () => {
        RegionService.getAll().then((resp) => {
            if(resp === false) {
                this.setState({ regionListFilter: [] });
            }
            this.setState({ regions: resp });
        });

    };
    loadAllRegions = () => {
        RegionService.getAllRegions().then((resp) => {
            if(resp === false) {
                this.setState({ allRegions: [] });
            }
            this.setState({ allRegions: resp });
        });

    };

    getRegionDropdown = () => {
        $(".regionSelect_options").addClass("active");
        $(".region_select_container").addClass("active");
        document.getElementById('regionId').focus();
        let selectedInstance = this.props.selectedInstance;
        let regionListFilter = [...this.state.regions];
        regionListFilter = regionListFilter.filter(item => item.id !== selectedInstance.region);
        this.setState({ regionListFilter: regionListFilter, isregionselected: false, dropRegion: '' }, () => this.scrollTop());
    };

    onFocusOut = (e) => {
        e.stopPropagation();
        if(!e.currentTarget.contains(e.relatedTarget)) {
            if(sessionStorage.inFocus === true) {
                sessionStorage.inFocus = false;
                return;
            }
            if(this.state.selectedRegion !== '') {
                this.setState({ dropRegion: '', isregionselected: true });
            } else if(this.state.selectedRegion === '') {
                this.setState({ dropRegion: '', isregionselected: false });
            }
            $(".regionSelect_options").removeClass('active');
            $(".region_select_container").removeClass("active");
        }
    };

    filterDropDown = (event) => {
        $(".regionSelect_options").addClass("active");
        let name = event.target.name;
        let val = event.target.value;
        let lcVal = val.toLowerCase();
        let selectedInstance = this.props.selectedInstance;
        let regionListFilter = [...this.state.regions];
        regionListFilter = regionListFilter.filter(item => item.id !== selectedInstance.region);

        let items = regionListFilter.filter(item => item.id.toLowerCase().includes(lcVal) || item.name.toLowerCase().includes(lcVal));

        this.setState({ regionListFilter: items, dropRegion: val });
    };

    getSelectedRegion = (event, regionOb) => {
        if(regionOb.status !== 1) {
            sessionStorage.inFocus = true;
            return;
        }
        sessionStorage.inFocus = false;
        $(".regionSelect_options").removeClass("active");

        let zone = this.state.regions.find(elem => elem.id === regionOb.id);
        if(zone.availability_zone != undefined) {

            this.setState({
                availabilityZone: zone.availability_zone
            });
        }
        let instanceName1 = this.state.instanceName;
        if(this.state.instanceName) {
            instanceName1 = instanceName1.replace(this.props.selectedInstance.region, regionOb.id);
            if(this.state.region) {
                instanceName1 = instanceName1.replace(this.state.region, regionOb.id);
            }
        }

        this.setState({ selectedRegion: regionOb.name, regionName: regionOb.id, countryName: regionOb.countryName, errorMessg: '', isregionselected: true, selectedDropDown: regionOb.id, regionErrorMessg: '', dropRegion: '', region: regionOb.id, instanceName: instanceName1 });
    };

    scrollTop() {
        if(this.scrollRef && this.scrollRef.current && this.scrollRef.current.scrollArea) {
            this.scrollRef.current.scrollArea.scrollTop();
        }
    }

    getComputeRegionUrl(region) {
        return this.state.computeRegionList.find(elem => elem.region === region).url;
    }

    getImageRegionUrl(region) {
        return this.state.regionList.find(elem => elem.region === region).url;
    }

    onRegionChange = (value) => {
        $('.create_module .planOption_sec .plan_box').removeClass('active');
        this.setState({ isAction: true, sshErrorMessg: '' });
        let val = value;
        let ComputeRegionUrl = this.getComputeRegionUrl(val);

        this.setState({ selectedRegionUrl: ComputeRegionUrl });
    };

    setImageRegionDetails(selectedRegion) {
        instanceService.getRegionListByType('image').then(data1 => {
            let data = data1;
            if(data && data.length > 0) {
                let val = data.find(item => item.region === selectedRegion);
                this.setComputeRegionDetails(val ? val.region : '');
                this.setState({ regionList: data });
            } else {
                this.setState({ isAction: false });
            }
            this.getMigrationLimit();
        });
    }

    getMigrationLimit = () => {
        let userId = localStorage.getItem("userId");
        Axios.get(API_HOST + '/inst-migration/migratelimit/' + userId, axiosRequestWithAuth).
            then(resp => {
                this.setState({
                    migrateCount: resp.data
                });
            })
            .catch(err => {
                console.log(err);
            });
    };


    setComputeRegionDetails(regionName) {
        instanceService.getRegionListByType('compute').then(data1 => {
            let data = data1;
            this.setState({ isAction: false });
            if(data && data.length > 0) {
                let val = data.find(item => item.region === regionName);
                this.setState({ computeRegionList: data, selectedRegionUrl: val ? val.url : '' });
            }
        });
    }

    close() {
        $('.migrate_slider').removeClass('active');
        $("body").removeClass("popup_no_scroll");
    }

    onInstanceMigrationSelection() {
        let name = this.props.selectedInstance.name;
        //if(name.length < 50 && name.indexOf("migrate") === -1) name = this.props.selectedInstance.name + '-migrated';
        let regOb = this.state.regions.find(elem => elem.id === this.props.selectedInstance.region);
        if(regOb) {
            regOb = regOb;
        }
        else {
            regOb = this.state.allRegions.find(elem => elem.id === this.props.selectedInstance.region);
            if(regOb) {
                regOb = regOb;
            }

        }


        this.setState({
            instanceName: name, dropRegion: '', isregionselected: false, selectedRegion: '', regionName: '', unitNameErrorMessg: '',
            regionErrorMessg: '', inst: this.props.selectedInstance, regOb: regOb, isAccept: false
        });
        setTimeout(() => {
            document.getElementById('regionId').focus();
        }, 100);
    }

    formChangeHandler = (event) => {
        let name = event.target.name;
        let val = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        if(event.target.name === "instanceName") {
            this.setState({ isNameError: false });
            if(val.length > 50) {
                return;
            }
            var nameRegex = new RegExp("^[-a-zA-Z0-9]*$");
            if(!nameRegex.test(val)) {
                this.setState({ unitNameErrorMessg: 'Name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)', isNameError: true });
            } else {
                this.setState({ unitNameErrorMessg: '', isNameError: false });
            }
        }

        this.setState({ [name]: val });
    };

    handlesubmit = (event) => {
        event.preventDefault();
        if(!this.validate()) {
            return;
        }

        if(localStorage.getItem("status") === 'S') {
            this.setState({
                message: i18n.t('inst_clone_suspended_failure'),
                msgType: "error",
            });
            return;
        }
        if(this.state.isCreateExternalDisabled) {
            this.setState({
                message: i18n.t('ext_creation_disabled'),
                msgType: "error"
            });
            return;
        }
        let unitName = this.state.instanceName.trim();
        this.props.bgShadowHandler(true);
        let snapReqBody = {
            createImage: {
                name: removeSpecialCharacter(this.props.selectedInstance.name) + '-' + dateInUTC()
            }
        };
        let requestBody = {
            server: {
                flavorRef: this.props.selectedInstance.flavor.id,
                imageRef: this.props.selectedInstance.image.id,
                key_name: this.state.keyName,
                max_count: 1,
                min_count: 1,
                name: unitName
            },
            backupEnabled: this.state.isBackupEnabled,
            privateIp: this.state.privateIp,
            userData: 'cloning',
            regionName: this.state.region,
            distrName: this.state.distrVersionName,
            rootLogin: this.state.isLoginData,
            discCode: this.state.discCode,
            toImageRegionUrl: this.getImageRegionUrl(this.state.region),
            fromImageRegionUrl: this.getImageRegionUrl(this.props.selectedInstance.region),
            fromComputeRegionUrl: this.getComputeRegionUrl(this.props.selectedInstance.region),
            instanceId: this.props.selectedInstance.id,
            snapReqBody: snapReqBody,
            fromRegionName: this.props.selectedInstance.region,
            isCloud: true,
            opType: 'migration',
            srcInstName: this.props.selectedInstance.name
        };
        let regionUrl = this.state.selectedRegionUrl;
        if(regionUrl === '') {
            regionUrl = this.getComputeRegionUrl(this.state.region);
        }
        instanceService.instMigration(JSON.stringify(requestBody), regionUrl).then(resp => {
            if(resp && resp === "LIMIT_EXCEDED") {
                this.close();
                this.props.bgShadowHandler(false);
                this.props.msgHandler('You have exceeded the maximum permissible attempts for migrating the instance. ', "error");

                this.setState({ isAction: false });
                return;

            }
            if(resp && resp.server) {
                this.props.getMigrationList();
                this.close();
                let instanceCreateName = "Instance migration request for " + requestBody.server.name + " has been initiated from region " + requestBody.fromRegionName + "to region " + requestBody.regionName;

                const requestBdy = {
                    "userId": localStorage.getItem("userId"),
                    "name": instanceCreateName,
                    "operation": "Instance migration request",
                    "region": this.state.region
                };
                AuditLog.storeAuditLogs(requestBdy, "instance").then((resp) => {
                    if(resp === false);
                });
                this.props.bgShadowHandler(false);
                this.props.msgHandler("Migration operation is in progress. It may take some time to complete depending upon the size of the instance.", "success");
                return;
            }
            if(resp && resp.message.includes("403")) {
                this.props.bgShadowHandler(false);
                this.props.msgHandler("Forbidden Access", "error");
                this.setState({ isAction: false });
                window.scrollTo(0, 0);
                return;
            }
            if(resp && resp.badRequest === undefined) {
                this.props.bgShadowHandler(false);
                if(resp.message && !resp.message.includes('timeout')) {
                    this.props.msgHandler(resp.message, "error");
                }
                this.setState({ isAction: false });
                return;
            }
            if(resp === undefined || resp.badRequest === undefined) {
                this.props.bgShadowHandler(false);
                this.props.msgHandler('Internal network issue. Please try again.', "error");

                this.setState({ message: 'Internal network issue. Please try again.', msgType: 'error', isAction: false });
                return;
            }
            this.props.bgShadowHandler(false);
            this.props.msgHandler('Failed to migrate the Instance', "error");

            this.setState({ isAction: false });
        }).catch(() => {

            this.setState({ isAction: false });
        });
    };

    validate() {
        var nameRegex = new RegExp("^[-a-zA-Z0-9]*$");
        if(this.state.selectedRegion === undefined || this.state.selectedRegion.trim() === '') {
            document.getElementById('regionId').focus();
            this.setState({ regionErrorMessg: 'Region is required.' });
            return false;
        }
        if(this.state.instanceName === undefined || this.state.instanceName.trim() === '') {
            document.getElementById('instanceName').focus();
            this.setState({ unitNameErrorMessg: 'Unit name is required.' });
            return false;
        }
        if(!nameRegex.test(this.state.instanceName.trim())) {
            document.getElementById('instanceName').focus();
            this.setState({ unitNameErrorMessg: 'Unit name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)' });
            return false;
        }
        return true;
    }

    render() {
        return (
            <div className="main_slider migrate_slider" id="migSlider">
                <div className="slider_bg_shadow"></div>
                <div className="slider_wrapper">
                    <div className="main_slider_container">
                        <div className="close_icon" data-tip data-for="migrateSlider" onClick={ () => this.close() }></div>
                        <ReactToolTip id="migrateSlider" place="left" effect="solid">Close</ReactToolTip>

                        <div className="migrate_slider_wrap">
                            <div className="head_block">
                                <h2>
                                    <span className="svg_wrap">
                                        <span className="icon">
                                            <svg x="0px" y="0px" viewBox="0 0 24 24" style={ { enableBackground: 'new 0 0 24 24' } } xmlSpace="preserve">
                                                <g>
                                                    <polyline className="mgi0" points="12.7,12 7.3,12 7.3,15.5 1.5,9.9 7.3,4.2 7.3,7.6 13.7,7.6  "></polyline>
                                                    <polyline className="mgi0" points="11.3,12 16.7,12 16.7,8.4 22.5,14.1 16.7,19.8 16.7,16.3 10.3,16.3  "></polyline>
                                                </g>
                                            </svg>
                                        </span>
                                    </span>
                                    Migrate Instance
                                </h2>
                            </div>

                            <div className="migrate_contWrap">
                                <p className="info_txt">The migrated instance will be created with the same password and SSH Keys (if any) as the original instance.</p>

                                <p className="imp_note"><strong>Important: </strong>On successful migration, this instance will be automatically deleted after 12 hours. You must verify the migrated instance and confirm or revert the migration within 12 hours.</p>

                                <div className="common_txtBox_row">
                                    <label>Current Region</label>
                                    <p className="current_region">
                                        <span className={ this.state?.regOb?.countryName?.toLowerCase() + " country_flag" }></span>
                                        { this.state.inst?.fullRegion }
                                    </p>
                                </div>

                                <div className="common_txtBox_row region_select" onBlur={ (e) => this.onFocusOut(e) }>
                                    <label>Regions</label>
                                    <div className="region_select_container" >
                                        <div className="slectBox" onClick={ this.getRegionDropdown }>
                                            <div className={ this.state.isregionselected ? "search_inp_box optSelect" : "search_inp_box optUnselect" }>
                                                <textarea id="regionId" name="dropRegion" value={ this.state.dropRegion } placeholder="Select a Region" onChange={ this.filterDropDown } autoComplete="chrome-off"></textarea>
                                            </div>
                                            <ul>
                                                <li className="selected_elem"><span className={ "country_flag " + this.state.countryName.toLowerCase() }></span>{ this.state.selectedRegion } ({ this.state.regionName })</li>
                                            </ul>
                                            <span className="dropArrow"> <svg className="header_nav_dropdown" viewBox="0 0 10 5">
                                                <title>drop-down</title>
                                                <polygon className="cls-1" points="5 5 0 0 10 0 5 5"></polygon>
                                            </svg>
                                            </span>
                                        </div>
                                        <div className="regionSelect_options">

                                            { this.state.regionListFilter.length <= 0 ?
                                                <ul className="noSearchRes" style={ { display: this.state.regionListFilter.length <= 0 ? "" : "none" } }>
                                                    <li>No matching region found</li>
                                                </ul>
                                                :
                                                <ul>
                                                    <ScrollArea ref={ this.scrollRef }
                                                        speed={ 0.8 }
                                                        style={ { maxHeight: "245px" } }
                                                        vertical={ true }
                                                        horizontal={ false }
                                                        minScrollSize={ 10 }
                                                        smoothScrolling={ false }
                                                        verticalScrollbarStyle={ { backgroundColor: "#C1C1C1", opacity: "1" } }
                                                        verticalContainerStyle={ { backgroundColor: "#F1F1F1", opacity: "1" } }
                                                        stopScrollPropagation={ true }
                                                    >
                                                        { this.state.regionListFilter.map((region, i) =>
                                                            <li className={ "option_elem " + region.statusClass } key={ i } onMouseDown={ (e) => this.getSelectedRegion(e, region) } disabled={ region.status !== 1 }><span className={ 'country_flag ' + region.countryName.toLowerCase() } ></span>{ region.name } ({ region.id })<span className="algin_right__arrow" style={ { display: region.status === 1 ? 'none' : '' } }>{ region.statusName }</span>
                                                            </li>
                                                        ) }
                                                    </ScrollArea>

                                                </ul>
                                            }
                                        </div>
                                        <span className="comm_error_msg">{ this.state.regionErrorMessg }</span>
                                    </div>
                                </div>

                                <div className="common_txtBox_row">
                                    <label>Name</label>
                                    <input type="text" placeholder="Provide a instance name" name="instanceName" id="instanceName" className="txt_box" value={ this.state.instanceName } onChange={ (e) => this.formChangeHandler(e) } maxLength="50" autoComplete="off" />
                                    <span className="comm_error_msg" >{ this.state.unitNameErrorMessg }</span>
                                </div>
                                <div className="imp_note warningMsg">
                                    <strong>Warning:</strong>
                                    <ul>
                                        <li>New IPv4 and IPv6 addresses will be assigned to the migrated instance which can be accessed on successful migration.</li>
                                        <li>Existing backups of this instance will not be migrated. After successful migration, backups will start as per the schedule in the new region.</li>
                                        <li>The existing firewalls (including any rules) associated with the instance will not be migrated. The default firewall will apply for the migrated instance.</li>
                                        <li>All DNS records, including Reverse DNS, are required to be updated after the completion of the migration operation.</li>
                                        <li>The block storage volumes attached to the instance will not be migrated to the new region.</li>
                                        <li>It may take up to 5 hours for the migration to complete.</li>
                                    </ul>
                                </div>
                                <div className="acptBlk">
                                    <label className={ this.state.isAccept ? 'checkBox active' : 'checkBox' }>
                                        <input type="checkbox" name="accept" value={ this.state.isAccept } onClick={ () => this.setState({ isAccept: !this.state.isAccept }) } checked={ this.state.isAccept } />
                                        <span className="checkmark"></span>
                                        <p className="">Accept (select the checkbox to proceed)</p>
                                    </label>
                                </div>


                                <div className="cta_wrap">
                                    <input type="button" name="" className={ this.state.isAccept && !this.state.isCreateExternalDisabled ? "common_cta_btn blue" : "common_cta_btn blue disabled" } value="Migrate" onClick={ (e) => this.handlesubmit(e) } disabled={ !this.state.isAccept || this.state.isCreateExternalDisabled } />
                                    <input type="button" name="" className="common_cta_btn transparentGrey" value="Cancel" onClick={ () => this.close() } />
                                </div>
                                <p className="info_txt limitText" style={ { display: this.state.migrateCount != -1 ? "" : "none" } }><strong>Note:</strong> The maximum permissible limit for migrating an instance is { this.state.migrateCount } times.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}